export default __webpack_public_path__ + "static/media/rsa_global.83b8f3d7.jpg";